
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["fileParser"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d39859ab7f29c62e8d91.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			